import { InputType, IQuestionOption } from 'types/forms';

export const ITEM_TYPE = 'QUESTION';

export const MAX_OPTIONS = 5;

export const createOptions = (type: InputType): IQuestionOption[] => {
  if (type === 'TEXT') return [];
  if (type === 'LINEAR_SCALE') {
    return [
      { id: 1, value: '', subValue: '1' },
      { id: 2, value: '', subValue: '5' },
    ];
  }
  return [{ id: 1, value: '옵션 1' }];
};
